module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("62y2a"))).then(() => parcelRequire('3a9aZ'));